import React from 'react';
import { LegacyText, themedColor } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import { TextReview } from '../types';
import { ReviewCard } from './ReviewCard';

const Review = styled(LegacyText)`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: fit-content;
`;

const ReviewerName = styled(LegacyText)`
  color: ${themedColor('boulder')};
  font-weight: 600;
`;

interface TextReviewCardProps {
  review: TextReview;
  onClick: () => void;
}

export const TextReviewCard: React.FC<TextReviewCardProps> = ({
  review: { shortText, reviewerName, source },
  onClick,
}) => {
  return (
    <ReviewCard onClick={onClick}>
      <Review
        type="main"
        fontSize={['1.5rem', '2.5rem', '3rem', '3rem']}
        mt={['1.6rem', '3.6rem', '3.6rem', '3.6rem']}
        lineHeight={[1.2]}
        fontWeight={600}
      >
        {shortText.split(' ').map((word, index) => (
          <span key={`${word}-${index}`}>{word}</span>
        ))}
      </Review>
      <ReviewerName
        type="main"
        fontSize={['0.8rem', '1.6rem', '1.6rem', '1.6rem']}
        mb={['1.2rem', '2.4rem', '2.4rem', '2.4rem']}
        lineHeight={[1.4]}
      >
        {reviewerName}
        ,&nbsp;
        {source}
      </ReviewerName>
    </ReviewCard>
  );
};
